module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp1_6.d6f32fec.png";